'use server'

import { apiRequest, ApiResponse } from '../request'

export interface Coupon {
    id: number
    code: string
    name?: string
    description?: string
    discountType: 'PERCENTAGE' | 'FIXED_AMOUNT'
    discountValue: number
    categoryId?: number
    category?: { id: number; name: string }
    subcategoryId?: number
    subcategory?: { id: number; name: string }
    products?: { id: number; catalogId: number; catalog: { id: number; name: string; media?: { url?: string | null }[] } }[]
    stores?: { id: number; storeConfigId: number; storeConfig: { id: number; name: string; subdomain: string; logo?: string } }[]
    minimumPurchase?: number
    startDate: string
    endDate: string
    maxUses?: number
    maxUsesPerClient?: number
    currentUses: number
    active: boolean
    companyId: number
    organizationId?: number | null
    createdAt: string
    updatedAt: string
}

/** Cupons da organização do usuário: o cupom vale em todas as filiais. */
export async function getCoupons(
    params?: { page?: number; limit?: number; search?: string },
): Promise<ApiResponse<Coupon[]>> {
    return apiRequest<Coupon[]>('coupons', {
        params: params ?? {},
    })
}

export async function getCoupon(
    id: number
): Promise<ApiResponse<Coupon>> {
    return apiRequest<Coupon>(`coupons/${id}`, {})
}

export async function createCoupon(
    data: Record<string, any>
): Promise<ApiResponse<Coupon>> {
    return apiRequest<Coupon>('coupons', { data }, 'post')
}

export async function updateCoupon(
    id: number,
    data: Record<string, any>
): Promise<ApiResponse<Coupon>> {
    return apiRequest<Coupon>(`coupons/${id}`, { data }, 'patch')
}

export async function deleteCoupon(
    id: number
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`coupons/${id}`, {}, 'delete')
}

export async function generateCouponCode(): Promise<ApiResponse<{ code: string }>> {
    return apiRequest<{ code: string }>('coupons/generate-code', {}, 'post')
}

/** Resultado da prévia do cupom num agendamento (centavos). */
export interface CouponQuote {
    couponId: number
    code: string
    amount: number
}

/**
 * Prévia: quanto o cupom abate do valor já com o desconto manual. Não grava nem conta
 * uso — o valor definitivo sai do backend ao salvar o agendamento.
 */
export async function quoteCoupon(data: {
    code: string
    clientId?: number
    items: Array<{ catalogId: number; quantity?: number; price: number }>
    manualTotal: number
    manualFinal: number
}): Promise<ApiResponse<CouponQuote>> {
    return apiRequest<CouponQuote>('coupons/quote', { data }, 'post')
}
